import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { WhiteListViewService, WhiteListItem, WhiteListQueryParams } from '../whiteList-view/whiteList-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { BootViewService } from '@/views/dashboard/manage/boot-optimize/_components/boot-view/boot-view.service'
import { ElMessage } from 'element-plus'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { TableOpt } from '@/components/cmTable/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'trust-list',
  props: {
    viewMode: { default: TableViewMode.preview }
  },
  emits: ["refresh", "viewAll"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const bootTypeDict = computed(() => ['', t('bootOptimize.bootTypeMenu'), t('bootOptimize.bootTypeTask'), t('bootOptimize.bootTypeRegSoft'), t('bootOptimize.bootTypeRegService')])

const props = __props

const emit = __emit

const injector = useReflectiveInjector([WhiteListViewService, BootViewService])
const whiteListService = injector.get(WhiteListViewService)
const bootService = injector.get(BootViewService)
const tableRef = ref<any>(null)

const { refreshList } = useCmTableListRefresh(tableRef)
const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const form = reactive<{ key_word?: string }>({
  key_word: ''
})
const formColumns = reactive<Record<string, never>>({})
const multipleSelection = ref<WhiteListItem[]>([])

const queryParams = computed<WhiteListQueryParams>(() => ({
  key_word: form.key_word || '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20
}))

const tableOpt = computed<TableOpt>(() => ({
  bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
  columns: [
    { prop: 'soft_name', label: t('bootOptimize.bootItem') },
    { prop: 'autorun_name', label: t('bootOptimize.appName') },
    { prop: 'autorun_desc', label: t('bootOptimize.description') },
    { prop: 'autorun_type', label: t('bootOptimize.autorunType'), slotName: 'autorun_type' }
  ],
  selection: true,
  usePagination: false,
  showSearch: false,
  showForm: false,
  showActionBar: false,
  showRightToolbar: true,
  rowKey: 'autorun_hash',
  path: 'list',
  totalPath: 'total',
  height: props.viewMode === TableViewMode.preview ? undefined : '100%',
  disableScrollLoad: props.viewMode === TableViewMode.preview,
  hiddenPageTool: props.viewMode === TableViewMode.preview
}))

function getListApi(params: any) {
  const query: WhiteListQueryParams = {
    key_word: params.key_word || '',
    page: params.page || 1,
    limit: params.limit || (props.viewMode === TableViewMode.preview ? 10 : 20)
  }
  return whiteListService.fetchWhiteList(query)
}

async function handleSearch(value: string) {
  form.key_word = value
  await refreshList()
}

async function handleQuery() {
  await refreshList()
}

function handleReset() {
  form.key_word = ''
  form.page = 1
  void refreshList()
}

function handleViewAll() {
  emit('viewAll')
}

function handleSelectionChange(selection: WhiteListItem[], _ids: string[]) {
  multipleSelection.value = selection
}

function untrustTer() {
  const ids = multipleSelection.value.map(item => item.autorun_hash)
  bootService.trustOrder({ autorun_list: ids, trust: false }).then(() => {
    tableRef.value?.tableRef?.clearSelection()
    multipleSelection.value = []
    ElMessage.success(t('bootOptimize.untrustCmdSuccess', { count: ids.length }))
    void refreshList()
    emit('refresh')
  }).catch(() => {
    ElMessage.error(t('bootOptimize.untrustCmdFailed', { count: ids.length }))
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    "table-opt": tableOpt.value,
    api: getListApi,
    modelValue: form,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
    "page-option": pageOption,
    "first-loading": true,
    onChangeSelected: handleSelectionChange
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: form,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
        "form-columns": formColumns,
        "show-search": true,
        "search-placeholder": _ctx.$t('bootOptimize.searchPlaceholderApp'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            disabled: !multipleSelection.value.length,
            type: "primary",
            size: "small",
            onClick: untrustTer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('bootOptimize.untrustItem')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_ctx.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                plain: "",
                onClick: handleViewAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "search-placeholder"])
    ]),
    autorun_type: _withCtx(({ row }: any) => [
      _createTextVNode(_toDisplayString(bootTypeDict.value[(row as WhiteListItem).autorun_type]), 1)
    ]),
    _: 1
  }, 8, ["table-opt", "modelValue"]))
}
}

})